"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBackgroundCheckPackageScreeningDto = instanceOfBackgroundCheckPackageScreeningDto;
exports.BackgroundCheckPackageScreeningDtoFromJSON = BackgroundCheckPackageScreeningDtoFromJSON;
exports.BackgroundCheckPackageScreeningDtoFromJSONTyped = BackgroundCheckPackageScreeningDtoFromJSONTyped;
exports.BackgroundCheckPackageScreeningDtoToJSON = BackgroundCheckPackageScreeningDtoToJSON;
exports.BackgroundCheckPackageScreeningDtoToJSONTyped = BackgroundCheckPackageScreeningDtoToJSONTyped;
const CheckrScreeningType_1 = require("./CheckrScreeningType");
/**
 * Check if a given object implements the BackgroundCheckPackageScreeningDto interface.
 */
function instanceOfBackgroundCheckPackageScreeningDto(value) {
    if (!('checkrScreeningType' in value) || value['checkrScreeningType'] === undefined)
        return false;
    if (!('checkrScreeningSubtype' in value) || value['checkrScreeningSubtype'] === undefined)
        return false;
    return true;
}
function BackgroundCheckPackageScreeningDtoFromJSON(json) {
    return BackgroundCheckPackageScreeningDtoFromJSONTyped(json, false);
}
function BackgroundCheckPackageScreeningDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'checkrScreeningType': (0, CheckrScreeningType_1.CheckrScreeningTypeFromJSON)(json['checkrScreeningType']),
        'checkrScreeningSubtype': json['checkrScreeningSubtype'],
    };
}
function BackgroundCheckPackageScreeningDtoToJSON(json) {
    return BackgroundCheckPackageScreeningDtoToJSONTyped(json, false);
}
function BackgroundCheckPackageScreeningDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'checkrScreeningType': (0, CheckrScreeningType_1.CheckrScreeningTypeToJSON)(value['checkrScreeningType']),
        'checkrScreeningSubtype': value['checkrScreeningSubtype'],
    };
}
//# sourceMappingURL=BackgroundCheckPackageScreeningDto.js.map